var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon arrow-icon",
    viewBox: "0 0 15 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.478 23.932c-.47.473-.47 1.24 0 1.713.47.473 1.232.473 1.702 0L14.75 13 2.18.355C1.71-.118.948-.118.478.355s-.47 1.24 0 1.713L11.345 13 .478 23.932z"
  })));
}

export default SvgArrowIconSv;